import { render, staticRenderFns } from "./FirstScreenComponent.vue?vue&type=template&id=356d486f"
import script from "./FirstScreenComponent.vue?vue&type=script&lang=js"
export * from "./FirstScreenComponent.vue?vue&type=script&lang=js"
import style0 from "./FirstScreenComponent.vue?vue&type=style&index=0&id=356d486f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports